"use client";
import PropTypes from "prop-types";
import React, { Fragment } from "react";

import styles from "./Footer.module.scss";

const defaultProps = {
  schoolName: "University of California, Berkeley",
  email: "datascience@berkeley",
  phoneNumber: "855-678-6437",
  copyright: "2025 UC Berkeley School of Information",
  links: [
    {
      id: "1",
      text: "Privacy Policy",
      url: "https://ischoolonline.berkeley.edu/legal/privacy-policy/",
    },
    {
      id: "2",
      text: "Terms of Service",
      url: "https://ischoolonline.berkeley.edu/legal/terms-of-use-agreement/",
    },
    {
      id: "3",
      text: "Your Privacy Choices",
      url: "#",
      className: "twoyou-cpra-ot",
      openOneTrust: true,
    },
  ],
  backgroundColor: "#003a70",
  textColor: "#fff",
};

export const DegreesFooter = function (props: any = defaultProps) {
  function openOneTrust(event: { preventDefault: () => void }) {
    event.preventDefault();

    if (typeof window.OneTrust === "undefined") {
      console.error("Error: OneTrust is not defined");
      return;
    }

    window.OneTrust.ToggleInfoDisplay();
  }

  return (
    <>
      <style>
        {`
          .degrees-footer {
            background-color: ${props.backgroundColor} !important;
            color: ${props.textColor} !important;
          }
        `}
      </style>
      {props.customCss && <style>{props.customCss}</style>}
      <footer className={`${styles.footer} degrees-footer footer`}>
        <div className={styles.footerContainer}>
          <p>{props.schoolName}</p>
          <p>
            <strong>{props.email}</strong>
            <span>
              <i className={`${styles.phoneIcon} material-icons`} aria-hidden="true">
                call
              </i>
            </span>
            <a href={`tel:${props.phoneNumber}`} target="_self" aria-label={`Phone number: ${props.phoneNumber}`}>
              {props.phoneNumber}
            </a>
            {" | "}
            <span className="footer-copyrightNoticePlp">{`© ${props.copyright}`}</span>
          </p>
          <p>
            {props.links.map((link: any, index: number) => (
              <Fragment key={link.id}>
                {index > 0 && " | "}
                <a
                  href={link.url}
                  target={link.target || ""}
                  className={link.className || ""}
                  rel="noreferrer"
                  onClick={link.openOneTrust ? openOneTrust : undefined}
                >
                  {link.text}
                </a>
              </Fragment>
            ))}
          </p>
        </div>
      </footer>
    </>
  );
};

DegreesFooter.propTypes = {
  schoolName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  copyright: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
      target: PropTypes.string,
      className: PropTypes.string,
    })
  ),
  backgroundColor: PropTypes.string,
  customCss: PropTypes.string,
};
